// extracted by mini-css-extract-plugin
export default {"authBtn":"MainBtn_authBtn__v9Wfc"};